import { render, staticRenderFns } from "./BuildingSelectbox.vue?vue&type=template&id=313e355a&"
import script from "./BuildingSelectbox.vue?vue&type=script&lang=js&"
export * from "./BuildingSelectbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports